const normalizeListingId = value =>
  typeof value === 'string' ? value : value?.uuid || value?.id?.uuid || value?.id || null;

export const applyPurchaseAvailabilityToListing = (listing, availabilityByListingId = {}) => {
  const listingId = normalizeListingId(listing?.id);
  const availability = listingId ? availabilityByListingId?.[listingId] : null;
  if (!listing || !availability) {
    return listing;
  }

  return {
    ...listing,
    attributes: {
      ...(listing.attributes || {}),
      publicData: {
        ...(listing.attributes?.publicData || {}),
        // This is a response-only overlay of the current seller state. It deliberately
        // uses a separate key so the legacy listing-level copy can never be mistaken
        // for a value resolved from the seller's current privateData.
        sellerVacationMode: Boolean(availability.vacationMode),
      },
    },
  };
};

export const applyPurchaseAvailabilityToListings = (listings = [], response = {}) => {
  const availabilityByListingId = response?.availabilityByListingId || {};
  return (Array.isArray(listings) ? listings : []).map(listing =>
    applyPurchaseAvailabilityToListing(listing, availabilityByListingId)
  );
};
